module.exports = __webpack_public_path__ + "static/media/satara_night_1k_edt.a0a9e99e.hdr";